import ImageSlider from "./Image-Slider.jsx";
import { getAllProjectData } from "../../data/util.js";
import "./Slideshow.css";

export default function Slideshow() {
  const projects = getAllProjectData();

  return (
    <div className="slideshow-container">
      <ImageSlider slides={projects} />
    </div>
  );
}
